{
  "fr": {
    "issue_category": {
      "labels": {
        "category_name": "Nom de la catégorie",
        "integration_warning": "Une intégration avec le module Après-vente de votre plateforme est active. Si vous souhaitez créer ou modifier des catégories, veuillez nous contacter.",
        "new_category": "Catégorie"
      }
    }
  }
}